/* ==========================================================================
   ReLEAF — homepage behaviour
   1. Header / navigation
   2. Mobile drawer
   3. MASS Posture Theory model (the page's one interactive moment)
   ========================================================================== */
/* ==========================================================================
   Shopify note: sections are torn down and re-injected while the merchant
   edits them in the Theme Editor. Everything below is therefore wrapped in
   named init functions bound to `shopify:section:load`, not run once on page
   load — otherwise the header and the MASS model render dead in the editor.
   ========================================================================== */
window.ReLEAF = (function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------- 1. Page load sequence */
  function markLoaded() {
    var nodes = document.querySelectorAll(".rl-scope");
    for (var i = 0; i < nodes.length; i++) { nodes[i].classList.add("is-loaded"); }
  }
  window.addEventListener("load", markLoaded);
  // Fallback so the hero is never left invisible if `load` never fires
  setTimeout(markLoaded, 2500);

  function initChrome() {

  /* --------------------------------------------- 1b. Header scroll state */
  var header = document.querySelector(".rl-header");
  if (header) {
    var stuck = false;
    var onScroll = function () {
      var should = window.scrollY > 8;
      if (should !== stuck) {
        stuck = should;
        header.classList.toggle("is-stuck", stuck);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------- 2. Desktop nav */
  var navItems = Array.prototype.slice.call(document.querySelectorAll(".rl-nav__item"));

  function closeAllNav(except) {
    navItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove("is-open");
      var t = item.querySelector(".rl-nav__top");
      if (t) t.setAttribute("aria-expanded", "false");
    });
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector(".rl-nav__top");
    if (!trigger) return;

    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = item.classList.contains("is-open");
      closeAllNav(item);
      item.classList.toggle("is-open", !isOpen);
      trigger.setAttribute("aria-expanded", String(!isOpen));
    });

    // Hover-opening is done in CSS (see .rl-nav__item:hover), so a pointer
    // user hovering then clicking can't immediately toggle the panel shut.
    // Keyboard users open it with Enter/Space and close it with Escape.
    trigger.addEventListener("focus", function () {
      closeAllNav(item);
    });
  });

  document.addEventListener("click", function () { closeAllNav(null); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeAllNav(null); closeDrawer(); }
  });

  /* ---------------------------------------------------- 3. Mobile drawer */
  var drawer = document.getElementById("rl-drawer");
  var burger = document.getElementById("rl-burger");
  var drawerClose = document.getElementById("rl-drawer-close");
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (burger) burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    if (drawerClose) drawerClose.focus();
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    if (burger) burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }

  if (burger) burger.addEventListener("click", openDrawer);
  if (drawerClose) drawerClose.addEventListener("click", closeDrawer);
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.tagName === "A") closeDrawer();
    });
  }

  } /* end initChrome */

  /* ==================================================================== */
  /* 4. MASS Posture Theory model                                          */
  /*                                                                       */
  /*    Two variables the visitor controls:                                */
  /*      phase (0-100)  — heel strike → midstance → propulsion            */
  /*      supported      — with the ReLEAF shell, or without               */
  /*                                                                       */
  /*    Everything on screen is derived from those two. Figures are shown   */
  /*    as relative indices, not clinical measurements.                    */
  /* ==================================================================== */
  function initMass() {
  /* ======================================================================
     MASS Posture Theory — walking-leg model with a live pressure map.

     One stride is simulated from real gait mechanics and shown two ways:
       - Side view: the leg walks across a pressure plate. The foot rolls
         over three "rockers" (heel, ankle, forefoot) so it never slides,
         and the shank angle comes from two-link IK against a hip moving
         forward at walking speed — which is why the knee straightens at
         heel strike, bends in loading response, and bends again at toe-off.
       - Bottom view: a per-pixel thermal pressure map of the sole.
     Both views read the same pressure grid, so they can't disagree. The
     model is illustrative: it shows how load moves and spreads, with no
     figures attached, per the client's review.
     ====================================================================== */
  var stage = document.getElementById("rl-mass");
  if (!stage) return;
  // Theme Editor re-renders sections: tear down any previous instance first
  if (window.__rlMass && window.__rlMass.destroy) window.__rlMass.destroy();

  var canvas = document.getElementById("rl-map");
  var side = document.getElementById("rl-side");
  var scrub = document.getElementById("rl-scrub");
  var playBtn = document.getElementById("rl-play");
  var phaseLabel = document.getElementById("rl-phase-label");
  if (!canvas || !side || !scrub || !canvas.getContext) return;
  var ctx = canvas.getContext("2d");
  var ticks = Array.prototype.slice.call(stage.querySelectorAll(".rl-mass__ticks span"));
  var segBtns = Array.prototype.slice.call(stage.querySelectorAll(".rl-seg button"));
  var NS = "http://www.w3.org/2000/svg";

  var segs = {
    shank: Array.prototype.slice.call(side.querySelectorAll('[data-seg="shank"]')),
    foot: Array.prototype.slice.call(side.querySelectorAll('[data-seg="foot"]')),
    toe: Array.prototype.slice.call(side.querySelectorAll('[data-seg="toe"]'))
  };
  var skinFoot = document.getElementById("rl-skin-foot");
  var lineFoot = document.getElementById("rl-line-foot");
  var archLine = document.getElementById("rl-arch-line");
  var soleShade = document.getElementById("rl-sole-shade");
  var shellPath = document.getElementById("rl-shell");
  var coverPath = document.getElementById("rl-cover");
  var orthoLayer = document.getElementById("rl-ortho");
  var shadow = document.getElementById("rl-shadow");
  var padGrad = document.getElementById("rl-padgrad");
  var midfoot = [document.getElementById("rl-midfoot"), document.getElementById("rl-midfoot-h")];
  var mt1 = [document.getElementById("rl-mt1"), document.getElementById("rl-mt1-h")];
  var lineFootH = document.getElementById("rl-line-foot-h");
  var flange = document.getElementById("rl-flange");
  var callout = document.getElementById("rl-callout");
  var calloutLine = document.getElementById("rl-callout-line");
  var calloutDot = document.getElementById("rl-callout-dot");
  var calloutText = document.getElementById("rl-callout-text");
  var calloutMsg = "", calloutW = 0;
  function note(name, fallback) { var v = stage.getAttribute("data-note-" + name); return v ? v : fallback; }
  var NOTES = {
    sideWith: note("side-with", "ReLEAF orthotic"),
    sideWithout: note("side-without", "Arch drops without support"),
    mapWith: note("map-with", "Pressure is distributed across the foot"),
    mapWithout: note("map-without", "Concentrated pressure on the heel and ball of the foot")
  };
  var mapNote = document.getElementById("rl-mapnote");
  var mapNoteMsg = "", noteBox = null, overlayNote = false;

  var state = { t: 0.2 + 0.6 * 0.5, supported: true, playing: !reduceMotion };

  /* ---------------------------------------------------------- math bits */
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function sm(x) { x = clamp(x, 0, 1); return x * x * (3 - 2 * x); }
  function eo(x) { x = clamp(x, 0, 1); return 1 - (1 - x) * (1 - x); }
  function ei(x) { x = clamp(x, 0, 1); return x * x; }
  function rot(a, p) {
    var r = a * Math.PI / 180, c = Math.cos(r), s = Math.sin(r);
    return { x: p.x * c - p.y * s, y: p.x * s + p.y * c };
  }
  function add(p, q) { return { x: p.x + q.x, y: p.y + q.y }; }
  function sub(p, q) { return { x: p.x - q.x, y: p.y - q.y }; }
  function keys(k, w) {
    for (var i = 0; i < k.length - 1; i++) {
      if (w <= k[i + 1][0]) {
        var f = sm((w - k[i][0]) / (k[i + 1][0] - k[i][0]));
        return k[i][1] + (k[i + 1][1] - k[i][1]) * f;
      }
    }
    return k[k.length - 1][1];
  }

  /* ----------------------------------------------------- side geometry
     Foot-local coordinates: origin at the ankle joint, y down, plantar
     surface at y=76 when the foot is flat. Toes hinge at J (the MTP joint). */
  var GY = 300;                    // pressure-plate surface in the side view
  var XF = 300;                    // ankle x while the foot is flat
  var J = { x: 122, y: 70 };
  var STRIDE = 1230, L1 = 440, L2 = 420, HIP_H = 916.35, HIP_A = 11.65;
  var HIP_X0 = 16 - STRIDE * 0.2;
  var ST0 = 0.2, ST1 = 0.8;        // stance occupies this slice of the cycle

  function contactY(sup) { return sup ? 82 : 76; }   // orthotic: 2 top cover + 4 shell
  function heelC(sup) { return { x: -44, y: contactY(sup) }; }
  function mtpC(sup) { return { x: 122, y: contactY(sup) }; }
  function toeC(sup) { return { x: 188, y: contactY(sup) }; }

  function archLoad(s) { return s < 0 ? 0 : sm((s - 0.06) / 0.2) * (1 - sm((s - 0.55) / 0.2)); }
  function archH(s, sup) { var L = archLoad(s); return sup ? 16 - 1 * L : 16 - 10 * L; }

  function plantarY(x, h) {
    if (x < -44) { var dx = x + 44; return 50 + Math.sqrt(Math.max(0, 676 - dx * dx)); }
    if (x < -12) return 76;
    if (x < 112) return 76 - h * Math.pow(Math.sin(Math.PI * (x + 12) / 124), 1.25);
    return 76;
  }

  function stancePose(s, sup) {
    var a = 0, tr = 0, A, P;
    if (s < 0.15) {
      a = -15 * (1 - eo(s / 0.15));
      P = { x: XF - 44, y: GY }; A = sub(P, rot(a, heelC(sup)));
    } else if (s < 0.5) {
      A = { x: XF, y: GY - contactY(sup) };
    } else if (s < 0.9) {
      a = 40 * ei((s - 0.5) / 0.4); tr = -a;
      P = { x: XF + 122, y: GY }; A = sub(P, rot(a, mtpC(sup)));
    } else {
      a = 40 + 16 * eo((s - 0.9) / 0.1); tr = -40;
      P = { x: XF + 188, y: GY };
      var tip = add(J, rot(tr, sub(toeC(sup), J)));
      A = sub(P, rot(a, tip));
    }
    return { A: A, a: a, tr: tr };
  }

  function hip(t) {
    return { x: HIP_X0 + STRIDE * t, y: GY - (HIP_H + HIP_A * Math.cos(4 * Math.PI * (t - 0.5))) };
  }

  // Two-link IK: the knee bends forward, the shank points ankle -> knee
  function shankAngle(H, A) {
    var d = sub(A, H), dist = Math.hypot(d.x, d.y);
    dist = clamp(dist, Math.abs(L1 - L2) + 1, L1 + L2 - 0.01);
    var g = Math.acos((L1 * L1 + dist * dist - L2 * L2) / (2 * L1 * dist));
    var psi = Math.atan2(d.y, d.x);
    var k1 = { x: H.x + L1 * Math.cos(psi + g), y: H.y + L1 * Math.sin(psi + g) };
    var k2 = { x: H.x + L1 * Math.cos(psi - g), y: H.y + L1 * Math.sin(psi - g) };
    var K = k1.x > k2.x ? k1 : k2;
    var u = sub(K, A), n = Math.hypot(u.x, u.y) || 1;
    return Math.atan2(u.x / n, -u.y / n) * 180 / Math.PI;
  }

  // Sole sample points used both for plate contact and for sinking checks
  function solePoint(x, sup) {
    if (x < -44) { var dx = x + 44; return { x: x, y: contactY(sup) - 0.006 * dx * dx }; }
    if (x > 186) return { x: x, y: contactY(sup) - (x - 186) * 0.7 };
    return { x: x, y: contactY(sup) };
  }
  function toWorld(pose, p) {
    var local = p.x > J.x ? add(J, rot(pose.tr, sub(p, J))) : p;
    return add(pose.A, rot(pose.a, local));
  }

  var SOLE_XS = [];
  for (var sx = -70; sx <= 194; sx += 6) SOLE_XS.push(sx);

  function pose(t, sup) {
    var p, s = -1;
    if (t >= ST0 && t <= ST1) {
      s = (t - ST0) / (ST1 - ST0);
      p = stancePose(s, sup);
    } else {
      var w = t > ST1 ? (t - ST1) / 0.4 : (t + 0.2) / 0.4;
      var TO = stancePose(1, sup), HS = stancePose(0, sup);
      var x = TO.A.x + (HS.A.x + STRIDE - TO.A.x) * sm(w);
      if (t < ST0) x -= STRIDE;
      var y = TO.A.y + (HS.A.y - TO.A.y) * w - 54 * Math.sin(Math.PI * Math.pow(w, 0.78));
      var A = { x: x, y: y };
      var dfTO = shankAngle(hip(ST1), TO.A) - TO.a;
      var dfHS = shankAngle(hip(ST0), HS.A) - HS.a;
      var df = keys([[0, dfTO], [0.18, 3], [0.75, 3], [1, dfHS]], w);
      p = { A: A, a: shankAngle(hip(t), A) - df, tr: keys([[0, -40], [0.14, -10], [0.26, 0], [1, 0]], w) };
    }
    // Never let the sole sink into the plate, whatever the pose
    var pen = 0;
    for (var i = 0; i < SOLE_XS.length; i++) {
      var wp = toWorld(p, solePoint(SOLE_XS[i], sup));
      if (wp.y - GY > pen) pen = wp.y - GY;
    }
    p.A.y -= pen;
    p.s = s;
    p.phi = shankAngle(hip(t), p.A);
    p.h = archH(s, sup);
    return p;
  }

  /* ------------------------------------------------- side-view paths */
  function f(n) { return n.toFixed(1); }
  function plantarPts(h, x0, x1, step, off) {
    var out = [];
    for (var x = x0; x <= x1 + 0.01; x += step) out.push(f(x) + " " + f(plantarY(x, h) + (off || 0)));
    return out;
  }
  function footPath(h) {
    return "M-46 -14 C-52 -6 -60 4 -64 14 C-68 24 -70 34 -70 46 L" + plantarPts(h, -70, 122, 4).join(" L") +
      " C128 76 136 64 136 50 C114 42 84 30 56 16 C42 9 32 4 24 6 Z";
  }
  function footOutline(h) {
    return "M-46 -14 C-52 -6 -60 4 -64 14 C-68 24 -70 34 -70 46 L" + plantarPts(h, -70, 122, 4).join(" L") +
      " M136 50 C114 42 84 30 56 16 C42 9 34 5 28 2";
  }
  function archLinePath(h) { return "M" + plantarPts(h, -12, 112, 4, -1.5).join(" L"); }
  function shellD(h) {
    // A thin rigid shell, like the HDPE shell of a real orthotic: it follows
    // the arch with air beneath it, and only its heel and forefoot rest on the
    // plate. SVG y points down, so on the heel circle (centre -44,50) 90deg is
    // the bottom and ~168deg is low on the back of the heel.
    var cx = -44, cy = 50, T = 4, out = [], inn = [], top = [], bot = [], d, x;
    for (d = 168; d >= 90; d -= 5) {                    // heel cup, outer wall (r=32)
      var r1 = d * Math.PI / 180; out.push(f(cx + 32 * Math.cos(r1)) + " " + f(cy + 32 * Math.sin(r1)));
    }
    for (x = -44; x <= 116; x += 4) bot.push(f(x) + " " + f(Math.min(plantarY(x, h) + 2 + T, 82)));
    for (x = 116; x >= -44; x -= 4) top.push(f(x) + " " + f(plantarY(x, h) + 2));
    for (d = 90; d <= 168; d += 5) {                    // heel cup, inner wall (r=28)
      var r2 = d * Math.PI / 180; inn.push(f(cx + 28 * Math.cos(r2)) + " " + f(cy + 28 * Math.sin(r2)));
    }
    return "M" + out.join(" L") + " L" + bot.join(" L") + " C119 81 121 80 121 79 L" + top.join(" L") +
      " L" + inn.join(" L") + " Z";
  }

  // Medial arch flange: the raised side wall of an orthotic that cradles the
  // arch. Seen from the inside of the foot it rises above the sole line, which
  // is what makes the shape read as an orthotic rather than a flat insole.
  function flangeD(h) {
    var top = [], bot = [];
    for (var x = -30; x <= 108; x += 4) {
      var k = Math.pow(Math.sin(Math.PI * (x + 30) / 138), 0.8);
      top.push(f(x) + " " + f(plantarY(x, h) - 12 * k));
      bot.push(f(x) + " " + f(plantarY(x, h) + 3));
    }
    return "M" + top.join(" L") + " L" + bot.reverse().join(" L") + " Z";
  }
  function coverD(h) {
    return "M-70 48 L" + plantarPts(h, -70, 122, 4).join(" L") + " L122 78 L" +
      plantarPts(h, -70, 122, 4, 2).reverse().join(" L") + " Z";
  }


  /* ---------------------------------------------------- pressure map
     Canvas is 240 x 520 logical units: heel at the bottom, toes at the top,
     seen from below (big toe on the left). The grid is coarse and drawn
     upscaled with smoothing, which gives the soft look of a real scan. */
  var CW = 240, CH = 520, GW = 80, GH = 174, DW = 240;   // DW = drawn width incl. note column
  var HEEL_Y = 506, TOE_Y = 36, LEN = HEEL_Y - TOE_Y;

  function crPath(pts) {
    var p = new Path2D(), n = pts.length;
    p.moveTo(pts[0][0], pts[0][1]);
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      p.bezierCurveTo(p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6,
                      p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6, p2[0], p2[1]);
    }
    p.closePath();
    return p;
  }
  var BODY = crPath([[122, 506], [152, 494], [164, 462], [166, 420], [168, 360], [172, 300], [178, 240],
    [186, 196], [192, 166], [190, 142], [180, 126], [160, 116], [136, 108], [112, 104], [90, 102],
    [72, 114], [62, 140], [62, 170], [70, 214], [84, 262], [90, 310], [88, 360], [84, 410], [84, 456], [94, 490]]);
  var TOES = [[86, 66, 21, 30, -6], [122, 70, 12, 18, 4], [148, 80, 11, 15, 10], [170, 94, 10, 13, 18], [188, 112, 9, 11, 26]];
  var TOE_PATHS = TOES.map(function (t) {
    var p = new Path2D(); p.ellipse(t[0], t[1], t[2], t[3], t[4] * Math.PI / 180, 0, Math.PI * 2); return p;
  });

  // Anatomical load regions: [x, y, sx, sy, ampWithout, ampWith, group]
  var REG = [
    [124, 452, 30, 34, 1.00, 0.60, "heel"],
    [156, 380, 12, 34, 0.50, 0.50, "lat1"], [162, 300, 13, 40, 0.55, 0.52, "lat2"], [170, 232, 13, 30, 0.50, 0.50, "lat3"],
    [104, 300, 24, 62, 0.05, 0.50, "arch"], [98, 230, 20, 32, 0.05, 0.46, "arch"],
    [82, 158, 16, 15, 0.86, 0.58, "mth1"], [110, 148, 15, 14, 1.00, 0.62, "mth"], [134, 150, 14, 13, 0.92, 0.60, "mth"],
    [156, 158, 13, 13, 0.72, 0.55, "mth"], [176, 170, 12, 13, 0.56, 0.50, "mth"],
    [86, 66, 16, 20, 0.90, 0.60, "hallux"], [122, 72, 9, 12, 0.55, 0.44, "toe"], [148, 82, 8, 10, 0.46, 0.40, "toe"],
    [170, 96, 7, 9, 0.40, 0.36, "toe"], [188, 113, 6, 8, 0.34, 0.32, "toe"]
  ];
  function hump(s, r0, r1, f0, f1) { return sm((s - r0) / (r1 - r0)) * (1 - sm((s - f0) / (f1 - f0))); }
  function groupW(g, s) {
    if (s < 0) return 0;
    switch (g) {
      case "heel": return hump(s, 0, 0.06, 0.30, 0.60);
      case "lat1": return hump(s, 0.04, 0.14, 0.40, 0.60);
      case "lat2": return hump(s, 0.08, 0.20, 0.50, 0.68);
      case "lat3": return hump(s, 0.12, 0.25, 0.60, 0.76);
      case "arch": return hump(s, 0.08, 0.20, 0.55, 0.72);
      case "mth": return (0.5 * sm((s - 0.1) / 0.25) + 0.5 * sm((s - 0.45) / 0.25)) * (1 - sm((s - 0.9) / 0.1));
      case "mth1": return (0.45 * sm((s - 0.12) / 0.25) + 0.55 * sm((s - 0.5) / 0.25)) * (1 - sm((s - 0.93) / 0.07));
      case "hallux": return sm((s - 0.45) / 0.3) * (1 - sm((s - 0.95) / 0.05));
      case "toe": return sm((s - 0.42) / 0.3) * (1 - sm((s - 0.92) / 0.08));
    }
    return 0;
  }
  function grf(s) { // double-hump ground reaction force, normalised
    if (s < 0) return 0;
    var a = Math.exp(-Math.pow((s - 0.22) / 0.16, 2)), b = Math.exp(-Math.pow((s - 0.78) / 0.16, 2));
    return 0.9 + 0.1 * Math.max(a, b);
  }

  // Separable Gaussian factors, per region, for both support states
  function factors(scaleWith) {
    return REG.map(function (r) {
      var sxv = r[2] * scaleWith, syv = r[3] * scaleWith, gx = new Float32Array(GW), gy = new Float32Array(GH);
      for (var i = 0; i < GW; i++) { var x = (i + 0.5) * CW / GW; gx[i] = Math.exp(-0.5 * Math.pow((x - r[0]) / sxv, 2)); }
      for (var j = 0; j < GH; j++) { var y = (j + 0.5) * CH / GH; gy[j] = Math.exp(-0.5 * Math.pow((y - r[1]) / syv, 2)); }
      return { gx: gx, gy: gy };
    });
  }
  var FAC = { without: factors(1), with: factors(1.22) };

  // Silhouette mask, rasterised once with anti-aliased edges
  var mask = new Float32Array(GW * GH);
  (function () {
    var m = document.createElement("canvas"); m.width = GW; m.height = GH;
    var c = m.getContext("2d");
    c.setTransform(GW / CW, 0, 0, GH / CH, 0, 0);
    c.fillStyle = "#fff"; c.fill(BODY); TOE_PATHS.forEach(function (p) { c.fill(p); });
    var d = c.getImageData(0, 0, GW, GH).data;
    for (var k = 0; k < GW * GH; k++) mask[k] = d[k * 4 + 3] / 255;
  })();

  // Static, seeded value noise: the mottled texture of a real sensor mat
  var noise = new Float32Array(GW * GH);
  (function () {
    var seed = 7, NX = 14, NY = 30, pts = [];
    function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
    for (var q = 0; q < NX * NY; q++) pts.push(rnd());
    for (var j = 0; j < GH; j++) for (var i = 0; i < GW; i++) {
      var fx = i / GW * (NX - 1), fy = j / GH * (NY - 1), x0 = Math.floor(fx), y0 = Math.floor(fy);
      var tx = sm(fx - x0), ty = sm(fy - y0);
      var v = pts[y0 * NX + x0] * (1 - tx) * (1 - ty) + pts[y0 * NX + x0 + 1] * tx * (1 - ty) +
              pts[(y0 + 1) * NX + x0] * (1 - tx) * ty + pts[(y0 + 1) * NX + x0 + 1] * tx * ty;
      noise[j * GW + i] = 0.93 + 0.14 * v;
    }
  })();

  // Thermal colour scale, as used by clinical pressure-mapping systems
  var STOPS = [[0.00, 0, 40, 180], [0.14, 0, 110, 230], [0.28, 0, 200, 230], [0.44, 40, 200, 90],
               [0.58, 170, 220, 40], [0.68, 250, 230, 20], [0.80, 255, 140, 0], [0.92, 230, 30, 20], [1.00, 170, 0, 0]];
  var LUT = new Uint8ClampedArray(256 * 3);
  for (var li = 0; li < 256; li++) {
    var v = li / 255, k2 = 0;
    while (k2 < STOPS.length - 2 && v > STOPS[k2 + 1][0]) k2++;
    var s0 = STOPS[k2], s1 = STOPS[k2 + 1], ft = clamp((v - s0[0]) / (s1[0] - s0[0]), 0, 1);
    for (var ch = 0; ch < 3; ch++) LUT[li * 3 + ch] = s0[ch + 1] + (s1[ch + 1] - s0[ch + 1]) * ft;
  }

  var grid = new Float32Array(GW * GH), rowMax = new Float32Array(GH);
  var gridCanvas = document.createElement("canvas"); gridCanvas.width = GW; gridCanvas.height = GH;
  var gctx = gridCanvas.getContext("2d"), img = gctx.createImageData(GW, GH);
  var copTrail = [], lastS = -1;

  function rowContact(p, sup) {
    var c = new Float32Array(GH);
    for (var j = 0; j < GH; j++) {
      var y = (j + 0.5) * CH / GH, u = clamp((HEEL_Y - y) / LEN, 0, 1);
      var wp = toWorld(p, solePoint(-62 + 254 * u, sup));
      // Soft tissue compresses gradually, so contact fades over ~9px of lift
      c[j] = 1 - sm((GY - wp.y - 0.5) / 9);
    }
    return c;
  }

  function computeGrid(p, sup) {
    var s = p.s, fac = sup ? FAC.with : FAC.without, contact = rowContact(p, sup), load = grf(s);
    var wts = REG.map(function (r) { return groupW(r[6], s); });
    var amps = REG.map(function (r, i) { return (sup ? r[5] : r[4]) * wts[i] * load; });
    var floor = (sup ? 0.14 : 0.10) * (s < 0 ? 0 : 1);
    var archL = archLoad(s);
    var sumP = 0, sumX = 0, sumY = 0, coefN = new Float32Array(REG.length), coefD = new Float32Array(REG.length);
    for (var j = 0; j < GH; j++) {
      var cr = contact[j], y = (j + 0.5) * CH / GH, base = j * GW, rmax = 0;
      if (cr < 0.002 || s < 0) { for (var z = 0; z < GW; z++) grid[base + z] = 0; rowMax[j] = 0; continue; }
      for (var r = 0; r < REG.length; r++) { coefN[r] = amps[r] * fac[r].gy[j]; coefD[r] = wts[r] * fac[r].gy[j]; }
      // Unsupported: the medial arch is lifted clear of the plate (it
      // flattens a little under load). Supported: the shell fills it.
      var bnd = 0;
      if (y > 180 && y < 420) {
        var arc = Math.pow(Math.sin(Math.PI * (y - 180) / 240), 0.9);
        bnd = sup ? 64 + 8 * arc : 72 + (62 - 16 * archL) * arc;
      }
      for (var i = 0; i < GW; i++) {
        var k = base + i, m = mask[k];
        if (m < 0.01) { grid[k] = 0; continue; }
        var x = (i + 0.5) * CW / GW, N = 0, D = 0;
        for (var q = 0; q < REG.length; q++) {
          if (coefD[q] > 1e-4) { var g = fac[q].gx[i]; N += coefN[q] * g; D += coefD[q] * g; }
        }
        var cov = 1 - Math.exp(-2.4 * D);
        var v = (D > 1e-5 ? (N / D) * cov : 0) + floor * (1 - 0.5 * cov);
        var voidF = bnd ? sm((x - (bnd - 10)) / 16) : 1;
        v *= m * cr * voidF * noise[k];
        grid[k] = v;
        if (v > rmax) rmax = v;
        if (v > 0.05) { sumP += v; sumX += v * x; sumY += v * y; }
      }
      rowMax[j] = rmax;
    }
    // Centre-of-pressure "gait line", as pressure-mapping software draws it
    if (s < 0 || s < lastS) copTrail = [];
    if (s >= 0 && sumP > 1) copTrail.push([sumX / sumP, sumY / sumP]);
    if (copTrail.length > 400) copTrail.shift();
    lastS = s;
  }

  var base = null, dpr = 1;
  function sizeCanvas() {
    var rect = canvas.getBoundingClientRect();
    if (!rect.height) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    // Beside-the-foot notes need a wider canvas; on phones the note sits
    // under the map instead and the canvas is just the footprint.
    overlayNote = !!mapNote && window.getComputedStyle(mapNote).position === "absolute";
    DW = overlayNote ? 400 : CW;
    canvas.width = Math.round(rect.height * (DW / CH) * dpr);
    canvas.height = Math.round(rect.height * dpr);
    base = document.createElement("canvas"); base.width = canvas.width; base.height = canvas.height;
    var b = base.getContext("2d");
    var sc = canvas.height / CH;
    b.setTransform(sc, 0, 0, sc, 0, 0);
    noteBox = null;
    b.fillStyle = "#E7EBEE"; b.fill(BODY); TOE_PATHS.forEach(function (p) { b.fill(p); });
    b.lineWidth = 1.4; b.strokeStyle = "#B9C2C8"; b.stroke(BODY); TOE_PATHS.forEach(function (p) { b.stroke(p); });
  }

  function drawMap() {
    if (!base) sizeCanvas();
    if (!base) return;
    var d = img.data;
    for (var k = 0; k < GW * GH; k++) {
      var v = grid[k], o = k * 4;
      if (v < 0.02) { d[o + 3] = 0; continue; }
      var li = Math.min(255, (v / 1.05 * 255) | 0);
      d[o] = LUT[li * 3]; d[o + 1] = LUT[li * 3 + 1]; d[o + 2] = LUT[li * 3 + 2];
      d[o + 3] = 255 * sm((v - 0.02) / 0.08);
    }
    gctx.putImageData(img, 0, 0);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(base, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    var sc = canvas.height / CH;
    ctx.drawImage(gridCanvas, 0, 0, CW * sc, CH * sc);
    ctx.setTransform(sc, 0, 0, sc, 0, 0);
    if (copTrail.length > 1) {
      ctx.beginPath();
      ctx.moveTo(copTrail[0][0], copTrail[0][1]);
      for (var i = 1; i < copTrail.length; i++) ctx.lineTo(copTrail[i][0], copTrail[i][1]);
      ctx.setLineDash([3, 3]); ctx.lineWidth = 1.6; ctx.strokeStyle = "rgba(20,28,24,.6)"; ctx.stroke();
      ctx.setLineDash([]);
      var c = copTrail[copTrail.length - 1];
      ctx.beginPath(); ctx.arc(c[0], c[1], 4.2, 0, Math.PI * 2);
      ctx.fillStyle = "#fff"; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = "rgba(20,28,24,.85)"; ctx.stroke();
    }
  }

  /* How visible the notes are: fade in once the foot is loaded, out before
     it leaves the plate, so they only ever describe what is on screen. */
  function noteAlpha(s) { return s < 0 ? 0 : sm((s - 0.04) / 0.06) * (1 - sm((s - 0.88) / 0.06)); }

  function drawMapNote(s, sup) {
    if (!mapNote) return;
    var msg = sup ? NOTES.mapWith : NOTES.mapWithout;
    if (msg !== mapNoteMsg) { mapNoteMsg = msg; mapNote.textContent = msg; noteBox = null; }
    var a = noteAlpha(s);
    if (!overlayNote) { mapNote.style.opacity = "1"; return; }   // phones: static caption under the map
    mapNote.style.opacity = a.toFixed(3);
    if (a < 0.01) return;
    if (!noteBox) {                                                // measured once per layout/text change
      var cr = canvas.getBoundingClientRect(), nr = mapNote.getBoundingClientRect(), k = DW / cr.width;
      noteBox = { x: (nr.left - cr.left) * k, y: (nr.top - cr.top) * k };
    }
    var sx = noteBox.x - 6, sy = noteBox.y + 9;
    ctx.save();
    ctx.globalAlpha = a;
    ctx.strokeStyle = "#183C26"; ctx.fillStyle = "#183C26"; ctx.lineWidth = 1.3;
    if (sup) {
      // A bracket along the outside of the foot spanning the part that is
      // carrying load right now: "across the foot", literally.
      var j0 = -1, j1 = -1;
      for (var j = 0; j < GH; j++) if (rowMax[j] > 0.12) { if (j0 < 0) j0 = j; j1 = j; }
      if (j0 >= 0) {
        var y0 = (j0 + 0.5) * CH / GH, y1 = (j1 + 0.5) * CH / GH, bx = 208;
        var my = clamp(sy, y0, y1);
        ctx.beginPath();
        ctx.moveTo(bx - 7, y0); ctx.lineTo(bx, y0); ctx.lineTo(bx, y1); ctx.lineTo(bx - 7, y1);
        ctx.moveTo(bx, my); ctx.lineTo(sx, sy);
        ctx.stroke();
      }
    } else {
      // Leaders to the heel and the ball, each shown only while that spot
      // is actually loaded, so a leader never points at an empty area.
      [[128, 452], [110, 152]].forEach(function (t) {
        var gi = Math.min(GW - 1, (t[0] / CW * GW) | 0), gj = Math.min(GH - 1, (t[1] / CH * GH) | 0);
        var la = sm((grid[gj * GW + gi] - 0.12) / 0.2);
        if (la < 0.02) return;
        ctx.globalAlpha = a * la;
        ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(t[0], t[1]); ctx.stroke();
        ctx.beginPath(); ctx.arc(t[0], t[1], 4.5, 0, Math.PI * 2);
        ctx.fillStyle = "#fff"; ctx.fill(); ctx.lineWidth = 2; ctx.stroke(); ctx.lineWidth = 1.3;
      });
    }
    ctx.restore();
  }

  /* -------------------------------------------- side-view pressure plate */
  var PAD_X0 = 120, PAD_X1 = 600, NB = 44, padStops = [];
  if (padGrad) {
    while (padGrad.firstChild) padGrad.removeChild(padGrad.firstChild);
    for (var b = 0; b < NB; b++) {
      var st = document.createElementNS(NS, "stop");
      st.setAttribute("offset", (b / (NB - 1)).toFixed(4));
      st.setAttribute("stop-opacity", "0");
      padGrad.appendChild(st); padStops.push(st);
    }
  }
  function updatePad(p, sup) {
    if (!padStops.length) return;
    var bins = new Float32Array(NB), dx = (PAD_X1 - PAD_X0) / (NB - 1);
    for (var j = 0; j < GH; j++) {
      if (rowMax[j] <= 0) continue;
      var y = (j + 0.5) * CH / GH, u = clamp((HEEL_Y - y) / LEN, 0, 1);
      var wp = toWorld(p, solePoint(-62 + 254 * u, sup));
      var bi = Math.round((wp.x - PAD_X0) / dx), vv = rowMax[j] * (1 - sm((GY - wp.y) / 3));
      if (bi >= 0 && bi < NB && vv > bins[bi]) bins[bi] = vv;
    }
    for (var q = 0; q < NB; q++) {
      var v = Math.max(bins[q], 0.55 * ((bins[q - 1] || 0) + (bins[q + 1] || 0)) / 2);
      var li = Math.min(255, (v / 1.05 * 255) | 0);
      padStops[q].setAttribute("stop-color", "rgb(" + LUT[li * 3] + "," + LUT[li * 3 + 1] + "," + LUT[li * 3 + 2] + ")");
      padStops[q].setAttribute("stop-opacity", sm((v - 0.02) / 0.08).toFixed(3));
    }
  }

  /* ------------------------------------------------------------ render */
  function setT(list, v) { for (var i = 0; i < list.length; i++) list[i].setAttribute("transform", v); }

  function phaseOf(s) {
    if (s < 0) return { name: "Swing", idx: -1 };
    if (s < 0.2) return { name: "Heel Strike", idx: 0 };
    if (s < 0.62) return { name: "Midstance", idx: 1 };
    return { name: "Toe-Off", idx: 2 };
  }

  function render() {
    var sup = state.supported, p = pose(state.t, sup);
    setT(segs.shank, "translate(" + f(p.A.x) + " " + f(p.A.y) + ") rotate(" + f(p.phi) + ")");
    setT(segs.foot, "translate(" + f(p.A.x) + " " + f(p.A.y) + ") rotate(" + f(p.a) + ")");
    setT(segs.toe, "rotate(" + f(p.tr) + " " + J.x + " " + J.y + ")");

    if (skinFoot) skinFoot.setAttribute("d", footPath(p.h));
    if (lineFoot) {
      var b0 = add(J, { x: 0, y: 7 }), b1 = add(J, rot(p.tr, { x: 0, y: 7 }));
      var lfD = footOutline(p.h) + " M" + f(b0.x) + " " + f(b0.y) + " A7 7 0 0 0 " + f(b1.x) + " " + f(b1.y);
      lineFoot.setAttribute("d", lfD);
      if (lineFootH) lineFootH.setAttribute("d", lfD);
    }
    if (archLine) archLine.setAttribute("d", archLinePath(p.h));
    if (soleShade) soleShade.setAttribute("d", "M" + plantarPts(p.h, -66, 122, 4, -3).join(" L"));
    if (shellPath) shellPath.setAttribute("d", shellD(p.h));
    if (coverPath) coverPath.setAttribute("d", coverD(p.h));
    if (orthoLayer) orthoLayer.style.opacity = sup ? "1" : "0";
    if (flange) flange.setAttribute("d", flangeD(p.h));

    // Arch collapse carries the bones with it: the navicular and cuneiforms
    // sink, and the 1st metatarsal tips down about its head.
    var drop = (16 - p.h) * 0.8;
    var mfT = "translate(0 " + f(drop) + ")", mtT = "rotate(" + f(-Math.atan2(drop, 50) * 180 / Math.PI) + " 121 58)";
    midfoot.forEach(function (g) { if (g) g.setAttribute("transform", mfT); });
    mt1.forEach(function (g) { if (g) g.setAttribute("transform", mtT); });

    // Callout: names what the viewer is looking at. Positioned in the frame
    // (not inside the rotating foot) so the text always stays level.
    if (callout) {
      var msg = sup ? NOTES.sideWith : NOTES.sideWithout;
      if (msg !== calloutMsg) {
        calloutMsg = msg; calloutText.textContent = msg;
        try { calloutW = calloutText.getComputedTextLength(); } catch (e) { calloutW = msg.length * 7.2; }
      }
      var anc = toWorld(p, { x: 40, y: plantarY(40, p.h) + (sup ? -7 : -1.5) });
      var tx = 636 - calloutW, ty = 158;
      calloutText.setAttribute("x", f(tx)); calloutText.setAttribute("y", f(ty));
      calloutDot.setAttribute("cx", f(anc.x)); calloutDot.setAttribute("cy", f(anc.y));
      calloutLine.setAttribute("points", f(anc.x) + "," + f(anc.y) + " " + f(tx - 10) + "," + f(ty - 4) + " " + f(tx - 4) + "," + f(ty - 4));
      var show = p.s >= 0.06 && p.s <= 0.9;
      callout.setAttribute("opacity", show ? "1" : "0");
    }

    if (shadow) {
      var mid = toWorld(p, { x: 60, y: contactY(sup) }), lift = clamp((GY - mid.y) / 90, 0, 1);
      shadow.setAttribute("cx", f(mid.x));
      shadow.setAttribute("opacity", (0.55 * (1 - lift)).toFixed(2));
    }

    computeGrid(p, sup);
    drawMap();
    drawMapNote(p.s, sup);
    updatePad(p, sup);

    var ph = phaseOf(p.s);
    if (phaseLabel) phaseLabel.textContent = ph.name;
    ticks.forEach(function (el, i) { el.classList.toggle("is-active", i === ph.idx); });
    if (state.playing) scrub.value = p.s >= 0 ? Math.round(p.s * 100) : (state.t > ST1 ? 100 : 0);
    stage.setAttribute("data-supported", String(sup));
    segBtns.forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-supported") === String(sup))); });
  }

  /* ---------------------------------------------------------- playback */
  var CYCLE = 3.0, raf = 0, last = 0, visible = false;
  function tick(now) {
    raf = 0;
    if (!state.playing || !visible) return;
    var dt = last ? Math.min(0.05, (now - last) / 1000) : 0;
    last = now;
    state.t = (state.t + dt / CYCLE) % 1;
    render();
    raf = requestAnimationFrame(tick);
  }
  function start() { if (!raf && state.playing && visible) { last = 0; raf = requestAnimationFrame(tick); } }
  function syncPlay() {
    if (!playBtn) return;
    playBtn.setAttribute("aria-pressed", String(state.playing));
    playBtn.setAttribute("aria-label", state.playing ? "Pause the walking animation" : "Play the walking animation");
    playBtn.classList.toggle("is-playing", state.playing);
  }

  function onScrub() {
    state.playing = false; syncPlay();
    state.t = ST0 + (ST1 - ST0) * (Number(scrub.value) / 100);
    render();
  }
  scrub.addEventListener("input", onScrub);
  if (playBtn) playBtn.addEventListener("click", function () {
    state.playing = !state.playing; syncPlay();
    if (state.playing) start(); else render();
  });
  segBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      state.supported = btn.getAttribute("data-supported") === "true";
      segBtns.forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
      render();
    });
  });

  var io = null, ro = null;
  if ("IntersectionObserver" in window) {
    io = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start();
    }, { threshold: 0.15 });
    io.observe(stage);
  } else { visible = true; }
  if ("ResizeObserver" in window) {
    ro = new ResizeObserver(function () { base = null; sizeCanvas(); render(); });
    ro.observe(canvas);
  }
  window.addEventListener("load", function () { base = null; sizeCanvas(); render(); });

  syncPlay();
  scrub.value = 50;
  sizeCanvas();
  render();
  start();

  window.__rlMass = {
    destroy: function () {
      if (raf) cancelAnimationFrame(raf);
      raf = 0; state.playing = false;
      if (io) io.disconnect();
      if (ro) ro.disconnect();
    },
    // exposed for automated checks only
    _state: state, _render: render, _pose: pose
  };
  } /* end initMass */

  function initAll() { initChrome(); initMass(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-run whichever section the merchant just re-rendered */
  document.addEventListener("shopify:section:load", function (e) {
    var id = e.target && e.target.getAttribute("data-rl-section");
    markLoaded();
    if (id === "mass") { initMass(); } else { initChrome(); }
  });
  document.addEventListener("shopify:section:unload", function () {
    document.body.style.overflow = "";
  });

  return { initAll: initAll, initChrome: initChrome, initMass: initMass };
})();
